import Carousel from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export { default as CarouselDots } from "./CarouselDots";
export { default as CarouselArrows } from "./CarouselArrows";
export { default as CarouselArrowIndex } from "./CarouselArrowIndex";

export default Carousel;
